import { Model, User } from ".";

export default class SafetyEmployeeInjuryReport extends Model {
	get singularNoun() {
		return "employee injury report";
	}

	get mutations() {
		return {
			employee: User,
			supervisor: User,
			assignedJobDutyBy: User
		};
	}

	resource() {
		return "safety/employee-injury-reports";
	}
}
